export default [
  {
    id: 'grand-entrance',
    title: 'Grand Entrance',
    image: '/assets/images/framed/Grand.jpg',
    category: 'Framed Hangings',
    variations: [
      {
        title: 'Grand Entrance',
        image: '/assets/images/framed/Grand.jpg',
      }
    ]
  },
  {
    id: 'home-on-a-hill',
    title: 'Home on a Hill',
    image: '/assets/images/framed/HomeOnAHill.jpg',
    category: 'Framed Hangings',
    variations: [
      {
        title: 'Home on a Hill',
        image: '/assets/images/framed/HomeOnAHill.jpg',
        description: <div>Small abstract pieces like this are very playful for me. I work with scraps I've generated from my other work, sticking them to a wall in my studio that I've covered with a flannel sheet. The scraps will stick to the flannel, and I can arrange and rearrange as much as I want, piecing parts together as I get sure of them.</div>,
      }
    ]
  },
  {
    id: 'fields',
    title: 'Fields',
    image: '/assets/images/framed/Fields.jpg',
    category: 'Framed Hangings',
    variations: [
      {
        title: 'Fields',
        image: '/assets/images/framed/Fields.jpg',
      }
    ]
  },
  {
    id: 'water-prism',
    title: 'Water Prism',
    image: '/assets/images/framed/WaterPrism.jpg',
    category: 'Framed Hangings',
    variations: [
      {
        title: 'Water Prism',
        image: '/assets/images/framed/WaterPrism.jpg',
      }
    ]
  },
  {
    id: 'phoenix',
    title: 'Phoenix',
    image: '/assets/images/framed/Phoenix.jpg',
    category: 'Framed Hangings',
    variations: [
      {
        title: 'Phoenix',
        image: '/assets/images/framed/Phoenix.jpg',
        description: <div>
            This wallhanging was raffled off on Dec. 16, 1997 along with many other creations by Putney area craftspeople to help a local woodworker rebuild her burnt-out studio. It was an interesting experience for me to work on a piece with a title and theme already in my head. 
        </div>
      }
    ]
  },
  {
    id: 'quiet-play',
    title: 'Quiet Play',
    image: '/assets/images/framed/QuietPlay.jpg',
    category: 'Framed Hangings',
    variations: [
      {
        title: 'Quiet Play',
        image: '/assets/images/framed/QuietPlay.jpg',
        description: <div>
            This was a very meditative piece for me, and reminded me of children's blocks.
        </div>
      }
    ]
  },
  {
    id: 'leap-of-faith',
    title: 'Leap of Faith',
    image: '/assets/images/framed/LeapOfFaith.jpg',
    category: 'Framed Hangings',
    variations: [
      {
        title: 'Leap of Faith',
        image: '/assets/images/framed/LeapOfFaith.jpg',
      }
    ]
  },
  {
    id: 'lagoon',
    title: 'Lagoon',
    image: '/assets/images/framed/fhLagoonT.jpg',
    category: 'Framed Hangings',
    variations: [
      {
        image: '/assets/images/framed/fhLagoon.jpg',
      }
    ]
  },
  {
    id: 'long-narrow',
    title: 'Long Narrow',
    image: '/assets/images/framed/fhLongNarrowT.jpg',
    category: 'Framed Hangings',
    variations: [
      {
        image: '/assets/images/framed/fhLongNarrow.jpg',
      }
    ]
  },
  {
    id: 'pacific',
    title: 'Pacific',
    image: '/assets/images/framed/fhPacificT.jpg',
    category: 'Framed Hangings',
    variations: [
      {
        image: '/assets/images/framed/fhPacific.jpg',
      }
    ]
  },
  {
    id: 'fh-water-passage',
    title: 'Water Passage',
    image: '/assets/images/framed/fhWaterPassageT.jpg',
    category: 'Framed Hangings',
    variations: [
      {
        image: '/assets/images/framed/fhWaterPassage.jpg',
      }
    ]
  }
];